import { render } from "./GitProfile.vue?vue&type=template&id=53944c31&scoped=true"
import script from "./GitProfile.vue?vue&type=script&lang=js"
export * from "./GitProfile.vue?vue&type=script&lang=js"

import "./GitProfile.vue?vue&type=style&index=0&id=53944c31&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Esther Ibom\\Desktop\\vue-exam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53944c31"]])

export default __exports__